import React, { Component } from "react";
import styles from "./cmsRetranslations.module.scss";
import { withRetranslations } from "../../../shared/containers/containerRetranslations";
import { MenuItem, Select } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { dateGridLocalTextOptions } from "../../../shared/services/dataGridLocalTextOptions";
import { withAuth } from "../../../shared/containers/containerAuth";
import { states } from "../../../reducers/queriesStates";

class CmsRetranslations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedRetranslation: null,
      retranslationsHosts: [],
    };
  }

  componentDidMount() {
    const { onGetRetranslations, onGetRetranslationsTypes } = this.props;

    onGetRetranslations();
    onGetRetranslationsTypes();
  }

  componentDidUpdate(prevProps) {
    const { retranslationsDataState, retranslations } = this.props;

    if (retranslationsDataState === states.READY && prevProps.retranslationsDataState === states.REQUEST) {
      const retranslationsHosts = retranslations.map((x) => {
        return {
          id: x.id,
          title: x.title,
        };
      });

      this.setState({ retranslationsHosts: retranslationsHosts });
    }
  }

  onChangeType(e) {
    this.setState({ selectedRetranslation: e.target.value });
  }

  getColumns() {
    const { data } = this.props;

    const renderTitleCell = (params) => {
      return (
        <a href={`/cms/companies/${params.row.id}`} target="_blank" rel="noreferrer">
          {params.row.title}
        </a>
      );
    };

    return [
      {
        field: "title",
        headerName: "Наименование",
        renderCell: renderTitleCell,
        width: 600,
        editable: data.permissions.includes(10003),
      },

      {
        field: "unitCount",
        headerName: "Количесвто транслируемых транспортных средств",
        width: 350,
        type: "number",
      },
    ];
  }

  getRows() {
    const { retranslations } = this.props;
    const { selectedRetranslation } = this.state;

    const retranslation = retranslations.filter((x) => {
      return x.id === selectedRetranslation;
    })[0];

    if (retranslation === undefined) {
      return [];
    }

    return retranslation.companies.map((x) => {
      return {
        id: x.id,
        title: x.title,
        unitCount: x.units.length,
      };
    });
  }

  render() {
    const { retranslationsTypes, retranslations } = this.props;
    const { selectedRetranslation, retranslationsHosts } = this.state;

    if (retranslationsTypes.length === 0) {
      return null;
    }

    const retranslation = retranslations.filter((x) => {
      return x.id === selectedRetranslation;
    })[0];

    let count = 0;

    if (retranslation !== undefined) {
      retranslation.companies.forEach((element) => {
        count += element.units.length;
      });
    }

    return (
      <div className={styles.cmsRetranslationsContainer}>
        Ретрансляция:
        <div className={styles.cmsRetranslationsSelector}>
          <div>
            <Select
              style={{ minWidth: "200px", height: "33px" }}
              onChange={this.onChangeType.bind(this)}
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={selectedRetranslation}
            >
              {retranslationsHosts.map((x, index) => {
                return (
                  <MenuItem key={index} value={x.id} className={styles.MuiButtonBase_resolve}>
                    {x.title}
                  </MenuItem>
                );
              })}
            </Select>
          </div>

          {retranslation !== undefined ? <div>Адрес: {retranslation.host}</div> : null}
          {retranslation !== undefined ? <div>Порт: {retranslation.port}</div> : null}
          {retranslation !== undefined ? (
            <div>
              По протоколу:{" "}
              {
                retranslationsTypes.types.filter((x) => {
                  return x.id === retranslation.protocol;
                })[0].title
              }
            </div>
          ) : null}

          {retranslation !== undefined ? (
            <div>
              Тип передачи:{" "}
              {
                retranslationsTypes.parameters.filter((x) => {
                  return x.id === retranslation.parameters;
                })[0].title
              }
            </div>
          ) : null}
        </div>
        <div>
          <b>Всего ТС: {count}</b>
        </div>
        <div className={styles.tableContainer}>
          <DataGrid
            rowHeight={30}
            ref={"DataGrid"}
            disableColumnSelector={true}
            disableColumnFilter={true}
            localeText={{
              ...dateGridLocalTextOptions,
              footerRowSelected: (count) => `Транспортных средств выбранно: ${count}`,
              MuiTablePagination: {
                disabled: false,
                rowsPerPage: 100,
                rowsPerPageOptions: 100,
                labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} из ${count === -1 ? `больше ${to}` : count}`,
              },
            }}
            rows={this.getRows()}
            columns={this.getColumns()}
            disableRowSelectionOnClick
          />
        </div>
      </div>
    );
  }
}

export default withAuth(withRetranslations(React.memo(CmsRetranslations)));
